const ENCommercialPlans = {
	"Adicionar Plano Comercial": "Add Commercial Plan",
	"Alterar Plano Comercial": "Update Commercial Plan",
	"Bloquear Excedido": "Block Exceeded",
	"Data inicial de validade": "Initial expiration date",
	"Deseja realmente excluir o plano comercial": "Do you really want to delete the commercial plan",
	"Deseja revalidar este plano comercial": "Do you want to revalidate this commercial plan",
	"Digite o nome do plano comercial para excluí-lo": "Enter the commercial plan name to delete it",
	"Duração (dias) do contrato": "Contract duration (days)",
	"Erro ao adicionar plano comercial": "Error adding commercial plan",
	"Erro ao alterar plano comercial": "Error updating commercial plan",
	"Erro ao excluir plano comercial": "Error deleting commercial plan",
	"Exclusão de Plano Comercial": "Delete Commercial Plan",
	"Interno": "Internal",
	"Itens do Plano": "Plan Items",
	"Não há nenhum item cadastrado para este plano": "There are no items registered for this plan",
	"Normal": "Normal",
	"Novo Plano Comercial": "New Commercial Plan",
	"Ocorreu um erro ao revalidar o plano de negócios": "An error occurred while revalidating the business plan",
	"Plano comercial é requerido": "Commercial plan is required",
	"Plano comercial adicionado com sucesso": "Commercial plan successfully added",
	"Plano comercial alterado com sucesso": "Commercial plan successfully updated",
	"Plano comercial excluído com sucesso": "Commercial plan successfully deleted",
	"Plano comercial revalidado com sucesso": "Commercial plan successfully revalidated",
	"Plano Comercial": "Commercial Plan",
	"Plano comercial": "Commercial plan",
	"Planos Comerciais": "Commercial Plans",
	"Planos comerciais": "Commercial plans",
	"Revalidar Plano Comercial": "Revalidate Commercial Plan",
	"Revalidar": "Revalidate",
	"Bloqueio excedido é requerido": "Block Exceeded is required",
	"Tipos não podem ser repetidos": "Types cannot be repeated",
	"É necessario preencher ao menos um item": "It is necessary to fill at least one item",
	"Nome do plano comercial não confere": "Commercial plan name does not match"
};

export default ENCommercialPlans;
